import { configureStore } from '@reduxjs/toolkit';
import rosterDraft from './rosterDraftSlice';
import domiciliaryScheduleDraft from './domiciliaryScheduleDraftSlice';
import domiciliaryPackagesDraft from './domiciliaryPackagesDraftSlice';

// Global Redux store. Holds the duty-roster + domiciliary-schedule + care-package
// draft queues; new slices can be added to the reducer map as other features
// adopt Redux.
export const store = configureStore({
    reducer: {
        rosterDraft,
        domiciliaryScheduleDraft,
        domiciliaryPackagesDraft,
    },
});

export default store;
